<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="board clear">
            <div class="viewer">
              <div v-if="viewType === 'claimDetail'" class="detail">
                <ClaimDetail
                  class="claim-detail"
                  searchType="claim"
                  :uID="uID"
                  :selectedID="selectedID"
                  @refresh="refresh"
                ></ClaimDetail>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ClaimDetail from '@/components/claim/ClaimDetail';

export default {
  components: {
    Toolbar,
    Navigation,
    ClaimDetail,
  },
  data: () => ({
    tab: 0,
    menu: null,
    viewType: 'claimDetail',
    selectedID: null,
    menuInfo: {
      mainTitle: 'Customer',
      mainName: '고객 CS 응대',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    downloadEvent: 0,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.uID = token.uID;
    this.menu = this.$route.name;
  },
  methods: {
    refresh() {
      this.$router.go(-1);

      /*
      this.selectedID = null;
      this.viewType = 'claimList';
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/claim/CustomerDetail.vue